<template>
    <div class="container">
        <div style=""></div>
        <div style="background:#fff" v-infinite-scroll="load">
            <div v-show="linkFrom !='space'" class="firstTitle" style="padding:20px 20px 15px 0px;border-bottom:1px solid #eaedf3;width:93%;margin-left:20px;">我的动态</div>
          
            <div  v-for="(item,index) in dongtaiList" :key="index">
             
            <div v-show="linkFrom !='space'" style="padding:15px 20px 0px 0px;width:96%;width:93%;margin-left:20px;color:#969798">
                    <span class="S">{{item.iscoll}}了{{item.typeLabel}}</span>
                    <span style="float:right">{{item.publishAgo}}</span>
            </div>
            <div class="article-info-haveImg" >
                <div class="title" style=" color:#175199" @click="goPageUrl(item)">
                        {{(item.title && item.title.length)>70?item.title.substring(0,70)+'...':item.title}}
                </div>
                <div class="headAndWrite" v-show="linkFrom !='space'">
                    <div>
                        <img v-if="item.headImg" class="img" :src="item.headImg" alt=""> 
                        <img v-else class="img" :src="item.cover" alt=""> 

                        
                    </div>
                    <div style="padding:0 10px;margin-top:-2px"  @click="goPageUrl(item)">
                        <div>{{item.userName}}</div>
                        <div style="color:#969798;font-size:14px;padding-top:1px">{{item.sign}}</div>
                    </div>
                </div>
                <div v-show="linkFrom !='space'" style="color:#c2c3c4;font-size:14px;">{{item.likeCount }} 人赞同了该{{item.typeLabel}}</div>
                <!-- <div class="contentStyle">
                    {{item.content.length>200?item.content.substring(0,200)+'...':item.content}}<span style="color:#175199"> 阅读原文 <i class="el-icon-arrow-down" style="color:#175199"></i></span>
                </div> -->
                <div class="contentStyle" style="display: flex;">
                    <div v-if="item.iscoll0 != '收藏'" style="margin-top:5px;padding-right:15px">
                        <img class="img" :src="item.cover" alt="">
                    </div>
                    <div>
                         <span v-if="item.typeLable !='视频'">{{(item.content && item.content.length)>200?item.content.substring(0,200)+'...':item.content}}</span>
                         <span style="color:#175199"  @click="goPageUrl(item)"> 阅读原文 <i class="el-icon-arrow-down" style="color:#175199"></i></span>
                         
                    </div>
                    
                </div>
                <div style="color:#c2c3c4;font-size:14px;height:40px;margin-top:15px">
                    <span :class="item.visIsZan==0?'zanTongStyle':'zanTongClick'">
                        <i class="el-icon-caret-top" style="width:10px;height:10px"></i>
                        
                        <span style="margin-left:8px">
                            <label @click="savePraise(item,1)" v-if="item.visIsZan==0">赞同 {{item.likeCount}}</label>
                            <label @click="savePraise(item,2)" v-else>已赞同 {{item.likeCount}}</label>
                            </span>
                    </span>
                    <!-- <span :class="!zantongDown?'zanTongStyle':'zanTongClick'" @click="zantongDown=!zantongDown" style="margin-left:5px">
                        <i class="el-icon-caret-bottom" ></i>
                    </span> -->
                    <span style="margin-left:20px" @click="goPageUrl(item)">
                        <!-- @click="pinglunDialog=true" -->
                        <span class="iconfont" style="color:#BBBBBB">&#xe61a; </span>
                        <span style="font-size:14px;">{{item.commentCount}} 条评论</span>
                    </span>
                    <span style="margin-left:20px" @click="saveColl(item)">
                        <i class="el-icon-star-on" style="font-size:16px;margin-right:2px" ></i>
                        <span style="font-size:14px;">收藏</span>
                    </span>
                    <!-- <span style="margin-left:20px">
                        <span class="iconfont" style="color:#BBBBBB">&#xe61a; </span>
                        <span style="font-size:14px;">举报</span>
                    </span> -->
                    <span></span>
                </div>
            </div>
            
            </div>
             
            <CollectionDialog :dialogAddCollection="dialogAddCollection" @cleanDialog="cleanDialog" :currArtData="currArtData" :collList="collList" />


       
            <div style="height:500px">
                <el-scrollbar style="height: 100%">
                    <el-dialog
                        title="评论"
                        :visible.sync="pinglunDialog"
                        width="30%"
                        
                        style="height:90vh"
                        center
                        >
                        
                        <!-- <div style="padding:20px">
                           
                            <el-input type="textarea" v-model="pComment" :class="pComment != '' ? 'no-null-myTxta' : 'myTxta'" class="txtarea countBg" show-word-limit resize="none" cols="30" @blur="getFocus(false)" @focus="getFocus(true)" :rows="viewRowNumber" placeholder="有想法快写下来吧..." maxlength="50"></el-input>
                            <div class="publish">
                                
                              
                                <button class="btnPublish" @click="addFaComment()">发表</button>
                            </div>
                        </div> -->
                        <div class="comment">
                            <div class="title">
                                <span>全部评论</span>
                                <span class="count">44条</span>
                            </div>
                            <CommentV v-for="n in 3" :key="n"/>
                        </div>
                        <span  slot="footer" style="display: flex;justify-content: center;" class="dialog-footer">
                        <!-- <el-button @click="pinglunDialog=false">取 消</el-button>
                        <el-button type="primary" @click="saveCollection">确定创建</el-button> -->
                        </span>
                        
                    </el-dialog>
                </el-scrollbar>
            </div>
        </div>
       
        <el-dialog title="" append-to-body size="medium" :visible.sync="loginWindow" width="900px">
           <Login :isWindow="true" @loginAfter="loginAfter" ></Login>
        </el-dialog>
        
         
    </div>
</template>
<script>
import CollectionDialog from '@/components/userCenter/CollectionDialog.vue'
import CommentV from '@/components/CommentV.vue'
import {querydongtai} from '@/comm/personalSapce'
import {addPraise, delPraise,queryFavoriteList} from "@/comm/api";
import Login from '@/views/Login.vue'
import {queryMyFavorite,queryMyCollFavorite} from '@/comm/personalSapce'
import {
     
      addComment,
     
    } from '@/comm/api'

export default {
  name: 'Dongtai',
  components: {
      CollectionDialog,
      CommentV,
      Login

  },
  props:{
    hasImg:{
        type:String,
        default:'no'
      },
    collection:{
      type:Boolean,
      default:false,
    },
    linkFrom:{
      type:String,
      default:'',
    },
    favoriteData:{   
        type:Array,
        default:null  }
  },
    created(){
        
        if(this.$store.state.users.userInfo && this.$store.state.users.userInfo.id){
            this.userId = this.$store.state.users.userInfo.id;
        }
        if(this.$route.query&&this.$route.query.authorId){
         //获取作者信息
         this.authorId=this.$route.query.authorId;
            
        }
        if(this.linkFrom == 'space'){
            this.dongtaiList = this.favoriteData;
            this.articleCount = this.favoriteData.length;
        }else{
            this.queryDongtaiList();
        }
        if(this.authorId){
        //获取作者信息
            // this.queryMyFavorite();
        }else{
            if(this.$route.query&&decodeURIComponent(this.$route.query.item)){
                //获取收藏夹信息
                var list = decodeURIComponent(this.$route.query.item);
                var param = JSON.parse(list);
                this.authorId = param.personId;
                // this.queryMyFavorite();

            }
        }
    },
    computed: {
        contractFile() {//监听查询条件
            return this.$store.state.space.spaceSearch
        }
    },
  watch:{
    contractFile(old,news) {
      this.pageNo=1;
      this.pageSize=10;
      this.isFrist=true;
      if(old){//按名称查询
        this.queryDongtaiList();
      }else{//查询所有
        // this.isLogin = false;
        this.queryDongtaiList();
      }
   }
  },
  data() {
    return {
      dialogAddCollection:false,
      zantongIndex:false,
      zantongDown:false,
      pinglunDialog:false,
      dongtaiList:[],
      pageNo:1,
      pageSize:10,
      addZan:0,
      currItem:null,
      userId:'0',
      loginWindow:false,
      currArtData:null,
      authorId:null,
      collList:[],
      isQuery:true,
      isFrist:true,
    }
  },
  methods:{
      load () {//滚动加载
        if(this.isQuery){
            this.isFrist=false;
            this.pageNo +=1;
          this.queryDongtaiList();
          console.log("调用一次");
        }
        
      },
     
      saveColl(data){
          this.dialogAddCollection = true;
          this.currArtData = data;
      },
     savePraise(data,type){
        
        if(!this.$store.state.users.userInfo){
        //需要登录
            this.loginWindow=true;
            return false;

        }
        var params = {};
        params.sourceId = data.id;
        
        params.sourceType = data.type;
        params.operateType = 1;
        params.operatorId = this.$store.state.users.userInfo.id;
        if(type ==1){
            data.visIsZan = 1;
            data.likeCount+=1;
            addPraise(params);
        }else{ 
            data.visIsZan = 0;
            data.likeCount-=1;
            delPraise(params);
        }
         
      },
      loginAfter(){
          this.loginWindow=false;
      },
      showCommentDialog(data){
          this.pinglunDialog=true;
          this.currItem = data;
      },
      goPageUrl(data){
        let url=null;
        if(data){
            if(data.typeLabel == '文章'){
                url="/articleInfo";
            }else if(data.typeLabel == '视频'){
                url="/videoInfo";
            }else if(data.typeLabel == '作品'){
                 url="/worksInfo";
            }else if(data.typeLabel == '问答'){
                url="/answerInfo";
            }else{

            }
        }
        let routeData = this.$router.resolve({ path: url, query: {  id: data.id } });
        window.open(routeData.href, '_blank');
       },
      queryDongtaiList(){
          //判断当前访问时是否时作者
          //
          
          let searchTitle = '';
          if(this.$store.state.space.spaceSearch && this.$store.state.space.spaceSearch.key && this.$store.state.space.spaceSearch.key == 5){
             searchTitle = this.$store.state.space.spaceSearch.title;
          }
          const that = this;
          querydongtai({"pageNo":this.pageNo,"pageSize":this.pageSize,"authorId":this.authorId,"title":searchTitle,"visitorId":this.userId}).then((res)=>{
          if(res.success){
            if(res.result.records.length == 0){
                that.isQuery=false;
                if(this.isFrist){
                    that.dongtaiList =[];
                }
            }else{
                if(this.isFrist){
                     that.dongtaiList =  res.result.records;
                }else{
                     res.result.records.forEach(element => {
                     that.dongtaiList.push(element);
                    });
                }
               
               that.articleCount = res.result.total;
            }
            
          }else{
            console.log(res.message);
          }
        });
      },
   
      cleanDialog(opt){
       
      if(opt == this.dialogAddCollection){
        return ;
      }
      this.dialogAddCollection=opt;
     
    },
  }
}
</script>
<style lang="stylus" scoped>
.publish{
      font-size: 12px;
      font-weight: 400;
      color: #262626;
      line-height: 17px;
      display flex;
      justify-content flex-end;
      align-items center;
      margin-top 15px;
      span{
        margin 0px 20px 0px 6px;
      }
      .btnPublish{
        width: 78px;
          height: 28px;
          background: #F72B17;
          border-radius: 4px;
          opacity: 0.15;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          border none;
          cursor pointer;
      }
    }
                
                    
    .comment{
        padding 20px;
        .title{
            font-size: 12px;
            font-weight: 400;
            color: #363636;
            line-height: 17px;
            .count{
              color #999999;
                font-size: 12px;
                font-weight: 400;
                line-height: 17px;
                margin-left 10px;
            }
        }
    }
    .container
        width 100%;
        border-radius 4px;
        cursor pointer;
        padding:00px 0 0px 0;
        font-family:  PingFang SC;
        .img
            width 206;
            height 116px;
            border-radius 4px 4px 0px 0px;
        .article-info
             margin-top:-5px;
             padding:15px 10px;
             background :#f4f4f5;
            .title
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align:left;
            .articleDesc
                font-size: 12px;
                font-weight: 400;
                color: #B8B9BA;
                line-height: 17px;
                margin-top 20px;
                text-align :left;
                .iconStyle{
                    padding:0 3px;
                }
            
        .article-info-haveImg
            // display :flex;
            // justify-content :flex-start;
            // 取消双击选中文字
            -moz-user-select:none;/*火狐*/
            -webkit-user-select:none;/*webkit浏览器*/
            -ms-user-select:none;/*IE10*/
            -khtml-user-select:none;/*早期浏览器*/
            user-select:none;
            margin-left:20px;
            border-bottom:1px solid #eaedf3;
            width:93%;
            padding-top:15px;
            .zanTongStyle
                background: #f5c0c0;
                padding: 7px 12px;
                color:rgb(23, 81, 153);
                border-radius:3px;
            .zanTongClick
                background: #f82b17;
                padding: 7px 12px;
                color:#fff;
                border-radius:3px;
            .headAndWrite
                display :flex;
                justify-content :start;
                padding:10px 0px 5px 0;
                img 
                    width:40px;
                    height:40px;
            .contentStyle
                padding:10px 0 0 0;
                width:100%;
                font-family:  PingFang SC;
                font-size:15px;
                line-height :25px;
                   
            .title
                font-size: 16px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align:left; 
                font-family: PingFangSC-Regular, PingFang SC;  
                font-weight: 600;
.toolDiv{
    background: #fff;
    padding-bottom:15px;
    margin-top:10px;
    background :#f4f4f5;
    width:100%;
    .tool{
        padding-right:3px;
        font-size: 12px;
        
        font-weight: 400;
        color: #b8b9ba;
        line-height: 20px;
        height :20px;
    }
}        
</style>